import moment from 'moment'

export const DEFAULT_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'

export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD'

export const DEFAULT_DATE_FORMAT_CN = 'YYYY年M月DD日'

export function calcAge (birthday, now) {
  if (!birthday) return null
  const momentNow = moment(now || new Date())
  const momentBirthday = moment(birthday)
  if (momentBirthday.isValid()) {
    const years = momentNow.diff(momentBirthday, 'years')
    if (years > 0) {
      return `${years} 岁`
    } else {
      const months = momentNow.diff(momentBirthday, 'months')
      if (months > 0) {
        return `${months} 月`
      } else {
        const days = momentNow.diff(momentBirthday, 'days')
        return days > 0 ? `${days} 天` : (days ? 'X 岁' : '0 岁')
      }
    }
  } else {
    return 'X 岁'
  }
}

export function calcAgeYears (birthday, now) {
  if (!birthday) return null
  const momentNow = moment(now || new Date())
  const momentBirthday = moment(birthday)
  return momentBirthday.isValid() ? momentNow.diff(momentBirthday, 'years') : null
}

export function calcDaysAgo (time, now) {
  const momentNow = moment(now || new Date())
  const momentTime = moment(time)
  return momentTime.isValid() ? momentNow.diff(momentTime, 'days') : 'X'
}
export function calcDaysRemain (time, now) {
  const momentNow = moment(now || new Date())
  const momentTime = moment(time)
  return momentTime.isValid() ? momentTime.diff(momentNow, 'days') : 'X'
}

export function calcDaysAgoText (time, now) {
  const days = calcDaysAgo(time, now)
  return days ? `${days}天前` : '今天'
}

export function calcDaysRemainText (time, now) {
  const days = calcDaysRemain(time, now)
  return days ? `${days}天后` : '今天'
}

export function compareDateTime (datetime1, datetime2) {
  if (datetime1 && datetime2) {
    const dt1 = moment(datetime1)
    const dt2 = moment(datetime2)
    if (dt1.isValid() && dt2.isValid()) {
      return dt1.toDate().getTime() - dt2.toDate().getTime()
    } else {
      return dt1.isValid() ? 1 : (dt2.isValid() ? -1 : 0)
    }
  } else {
    return datetime1 ? 1 : (datetime2 ? -1 : 0)
  }
}

export function formatDateTime (datetime, format, parseFormat, parseStrict) {
  if (!datetime) return ''
  const momentDateTime = moment(datetime, parseFormat, parseStrict)
  return momentDateTime.isValid()
    ? momentDateTime.format(format || DEFAULT_DATETIME_FORMAT)
    : String(datetime)
}

export function formatStartOfDay (datetime, format, parseFormat, parseStrict) {
  if (!datetime) return ''
  const momentDateTime = moment(datetime, parseFormat, parseStrict)
  return momentDateTime.isValid()
    ? momentDateTime.startOf('day').format(format || DEFAULT_DATETIME_FORMAT)
    : String(datetime)
}

export function formatEndOfDay (datetime, format, parseFormat, parseStrict) {
  if (!datetime) return ''
  const momentDateTime = moment(datetime, parseFormat, parseStrict)
  return momentDateTime.isValid()
    ? momentDateTime.endOf('day').format(format || DEFAULT_DATETIME_FORMAT)
    : String(datetime)
}

export function formatDate (date, format, parseFormat, parseStrict) {
  if (!date) return ''
  const momentDateTime = moment(date, parseFormat, parseStrict)
  return momentDateTime.isValid()
    ? momentDateTime.format(format || DEFAULT_DATE_FORMAT)
    : String(date)
}

export function formatDateCn (date, format, parseFormat, parseStrict) {
  if (!date) return ''
  const momentDateTime = moment(date, parseFormat, parseStrict)
  return momentDateTime.isValid()
    ? momentDateTime.format(format || DEFAULT_DATE_FORMAT_CN)
    : String(date)
}

export function addOrSubtractDateTime (time, operator = 'add', num = 0, unit = 'days') {
  if (!time) {
    return ''
  }
  let result
  if (moment()[operator] && typeof moment()[operator] === 'function') {
    result = moment(time)[operator](num, unit)
  } else {
    result = moment(time)
  }
  return result.isValid()
    ? result.format(DEFAULT_DATETIME_FORMAT)
    : String(time)
}
